import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { set, cloneDeep } from "lodash"
import { ActionCreators } from "../../../../redux/actions"
import PanelFooter from "../../../../components/panel/PanelFooter"
import PanelHeader from "../../../../components/panel/PanelHeader"
import PanelHeaderButton from "../../../../components/buttons/PanelHeaderButton"
import { CONFIRM_WELL_INSTANCE_REMOVE } from "../../../../panelConsts"
import PH from "../../../../lib/PanelHelper"

class EditWellInstance extends Component {
  constructor(props) {
    super(props)

    const { panelData } = props

    const formattedData = panelData.wells.length > 0 ? panelData.wells[0] : null

    this.state = {
      pages: props.pages,
      options: props.options,
      postData: formattedData,
      validated: {},
    }
  }

  componentDidMount() {
    const {
      panelOpen: { index },
      nextStepInPanel,
    } = this.props
    const { postData } = this.state

    if (postData.booking_type && index === 0) {
      nextStepInPanel()
    }
  }

  componentDidUpdate(prevProps) {
    const {
      panelOpen: { index },
    } = this.props
    const { pages, validated } = this.state

    // TODO: if object has prod that it does not need to be validated
    if (index !== prevProps.panelOpen.index) {
      if (!validated[index]) {
        if (pages[index].options.validated) {
          this.setSubPageValidated(index, pages[index].options.validated)
        }
      }
    }
  }

  onUpdate = (obj) => {
    const { postData } = this.state

    const nPostData = cloneDeep(postData)
    Object.entries(obj).forEach(([key, val]) => {
      if (val || val === "") {
        if (key.includes(".")) {
          set(nPostData, key, val)
        } else {
          nPostData[key] = val
        }
      } else {
        delete nPostData[key]
      }
    })

    this.setState({
      postData: nPostData,
    })
  }

  onSubmit = () => {
    const { saveWellInstance } = this.props

    const data = cloneDeep(this.state.postData)

    saveWellInstance(data)
  }

  setSubPageValidated = (index, isValidated) => {
    const validated = cloneDeep(this.state.validated)

    validated[index] = isValidated

    this.setState({
      validated,
    })
  }

  removeWellFromSchedule = () => {
    const { setWellInstanceToRemove, openPanelWithType } = this.props
    const { postData } = this.state
    setWellInstanceToRemove(postData)
    openPanelWithType(CONFIRM_WELL_INSTANCE_REMOVE)
  }

  getPage = (index, pages, postData) =>
    PH.getPage(
      index,
      pages[index],
      (val) => this.onUpdate(val),
      (i, val) => this.setSubPageValidated(i, val),
      postData
    )

  render() {
    const { pages, postData, validated } = this.state
    const {
      panelOpen: { index },
    } = this.props

    const headerButtons = postData.id
      ? [<PanelHeaderButton key={"Preview-request-button-modal"} value={"Remove well"} handleClick={this.removeWellFromSchedule} />]
      : null

    return [
      <PanelHeader key={"PanelHeader"} buttons={headerButtons} />,
      <div key={"Panel__Page"} className="Panel__Page Panel-Request">
        <div className="Panel__Page-Container PanelContent">{this.getPage(index, pages, postData)}</div>
        <PanelFooter index={index} data={pages[index]} validated={validated[index]} onSubmit={(val) => this.onSubmit(val)} />
      </div>,
    ]
  }
}

EditWellInstance.propTypes = {
  panelOpen: PropTypes.object,
  panelData: PropTypes.object,
  options: PropTypes.object,
  requestToEdit: PropTypes.object,
  pages: PropTypes.array,
  index: PropTypes.number,
  saveWellInstance: PropTypes.func,
  nextStepInPanel: PropTypes.func,
  setWellInstanceToRemove: PropTypes.func,
  openPanelWithType: PropTypes.func,
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch)
}

function mapStateToProps(state) {
  return {
    panelOpen: state.application.panelOpen,
    panelData: state.application.panelData,
    requestToEdit: state.requestData.requestToEdit,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditWellInstance)
